import { motion } from "framer-motion";
import React from "react";
import CandidateCard from "./CandidateCard";

const mockCandidates = [
  {
    name: "Sunita Yadav",
    photo: "/image/sunita-yadav.jpg",
    party: "Lok Shakti Party",
    position: "Ward Councillor",
    constituency: "Ward No. 5, Patna",
  },
  {
    name: "Rohit Kumar",
    photo: "/image/rohit-kumar.jpg",
    party: "Independent",
    position: "MLA",
    constituency: "Buxar, Bihar",
  },
  {
    name: "Lata Singh",
    photo: "/image/lata-singh.jpg",
    party: "Indian National Congress",
    position: "Panchayat Head",
    constituency: "Sikar, Rajasthan",
  },
];

const CandidateListSection = () => {
  return (
    <section className="bg-gradient-to-b from-orange-50 via-white to-green-50 py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-4xl font-extrabold text-orange-700 mb-3 drop-shadow-sm">
          🌟 भारत के जन-प्रतिनिधि
        </h2>
        <p className="text-gray-600 max-w-xl mx-auto text-lg">
          Ward से लेकर MP तक — जानिए आपके इलाके में कौन खड़ा है आपकी आवाज़ उठाने के लिए।
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {mockCandidates.map((candidate, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.3 }}
          >
            <CandidateCard {...candidate} />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default CandidateListSection;
